import React from "react";
import { SORT_A, SORT_D } from "../../../utils/Constants";

export default function Sorting({
  sort,
  handleSort,
  column,
  columnName,
  defaultSorting,
  breakName = false,
  disabled = false,
}) {
  const iconStyle = {
    marginLeft: "5px",
    pointerEvents: disabled ? "none" : "auto",
    opacity: disabled ? 0.4 : 1,
    cursor: disabled ? "not-allowed" : "pointer",
  };

  return (
    <>
      {breakName === "true" ? (
        <div className="d-flex align-items-center">
          <span>{columnName}</span>

         
        </div>
      ) : (
        <span>
          {columnName}

         
        </span>
      )}
    </>
  );
}
